module.exports = __webpack_public_path__ + "static/media/pasta_carbonara.47dfbbee.jpg";